import { useEffect, useRef, useState } from "react";

/**
 * Keep below-the-fold UI out of the initial render tree until it approaches
 * the viewport. The reserved space limits layout movement while the section
 * waits to mount; once mounted, it stays available for smooth scrolling.
 */
export default function DeferredMount({ children, minHeight = 320, rootMargin = "700px 0px" }) {
  const hostRef = useRef(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready) return;
    const node = hostRef.current;
    if (!node || typeof IntersectionObserver === "undefined") {
      setReady(true);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setReady(true);
        observer.disconnect();
      }
    }, { rootMargin });
    observer.observe(node);
    return () => observer.disconnect();
  }, [ready, rootMargin]);

  return (
    <div ref={hostRef} style={ready ? undefined : { minHeight }}>
      {ready ? children : null}
    </div>
  );
}
